import React from 'react';
import loadable from '@loadable/component';
import { fetchDestination, clearMerchandise } from 'store/destination/destinationActions';
import getRouteParams from 'lib/destination/getRouteParams';

export const AsyncDestinationLayout = loadable(() => import(/* webpackPrefetch: true */ './DestinationLayout'));

const Destination = () => <AsyncDestinationLayout />;

Destination.activeSplits = [];

Destination.onEnterPage = ({ route, store }) => {
  const params = getRouteParams(route);

  store.dispatch(fetchDestination(params));
};

Destination.onExitPage = ({ store }) => {
  store.dispatch(clearMerchandise());
};

export default Destination;
